import React from 'react';
import cn from 'classnames';

import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';
import Link from 'components/link/Link';

import { INestedMenu } from 'source/NFR.types';

const NestedMenu: React.FC<INestedMenu> = ({ accordion, title, linkList = [], linkLists = [], mainPageLink }) => {
  const isDesktop = useIsScreenSize('lg');

  return (
    isDesktop !== undefined && (
      <Accordion {...accordion} initiallyOpen={isDesktop} buttonTextForLabel={title}>
        {({ Button, Collapse, isOpen }) => (
          <div className="nested-menu">
            <div className="nested-menu--inner">
              {!isDesktop && (
                <Button className="nested-menu--button">
                  {title && <h2 className="nested-menu--title">{title}</h2>}
                  <Icon
                    className={cn('nested-menu--button-icon', {
                      'nested-menu--button-icon--close': isOpen
                    })}
                    name={isOpen ? 'x' : 'menu'}
                    fill={!isOpen}
                  />
                </Button>
              )}
              {React.createElement(
                isDesktop ? React.Fragment : Collapse,
                null,
                <>
                  {isDesktop && title && (
                    <h2 className="nested-menu--title">
                      <Link url={mainPageLink ? mainPageLink.url : ''} text={title} />
                    </h2>
                  )}
                  {!isDesktop && mainPageLink && <Link className="nested-menu--main-page-link" {...mainPageLink} />}
                  <ul className="nested-menu--list">
                    {linkList?.map(({ link, isCurrent }) => (
                      <li
                        className={cn('nested-menu--inner-list-item', 'nested-menu--inner-list-item--single-link', {
                          'nested-menu--inner-list-item--current-page': isCurrent
                        })}
                        key={link.text}
                      >
                        <Link {...link} noHoverEffect />
                      </li>
                    ))}
                    {linkLists?.map(({ accordion, linkList, section = {}, isCurrent }, linkListIndex) => (
                      <Accordion {...accordion} initiallyOpen={isCurrent} key={`${section.title}-${linkListIndex}`}>
                        {({ Button, Collapse, isOpen }) => (
                          <li
                            className={cn('nested-menu--list-item', {
                              'nested-menu--list-item--current-section': isCurrent
                            })}
                          >
                            <Button className="nested-menu--list-item-button">
                              <Icon
                                className={cn('nested-menu--list-item-icon', {
                                  'nested-menu--list-item-icon--is-open': isOpen
                                })}
                                name="small-arrow-down"
                                fill={true}
                              />
                              <h3 className="nested-menu--list-item-title">
                                <b>{section.number}</b> {section.title}
                              </h3>
                            </Button>
                            <Collapse>
                              <ul className="nested-menu--inner-list">
                                {linkList?.map(({ link, isCurrent }) => (
                                  <li
                                    className={cn('nested-menu--inner-list-item', {
                                      'nested-menu--inner-list-item--current-page': isCurrent
                                    })}
                                    key={link.text}
                                  >
                                    <Link {...link} noHoverEffect />
                                  </li>
                                ))}
                              </ul>
                            </Collapse>
                          </li>
                        )}
                      </Accordion>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        )}
      </Accordion>
    )
  );
};

NestedMenu.displayName = 'NestedMenu';

export default NestedMenu;
